<template>
  <div>
    <div v-if="loading">
      <img src="ui/img/loading.svg" alt="Time Loader" />
      <p><i>Please wait...</i></p>
    </div>
    <table class="responsive-table striped" v-else>
      <thead>
        <tr>
          <th>S/N</th>
          <th>Title</th>
          <th>Reciever</th>
          <th>Service</th>
          <th>Amount</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="length <= 0">
          <td colspan="6">
            No recent transaction
          </td>
        </tr>
        <tr v-for="(item, index) in transactions" :key="index" v-else>
          <th>{{ index + 1 }}</th>
          <td>{{ item.title }}</td>
          <td>{{ item.receiver }}</td>
          <td>{{ item.service }}</td>
          <td>{{ item.amount }}</td>
          <td>{{ item.date }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'DataHistory',
  components: {},
  mounted() {
    $('.bills__side__wrapper').removeClass('left_out')
    this.getDataHistory()
  },
  data() {
    return {
      fields: {
        action: 'last_transaction',
        service: 'data'
      },
      transactions: '',
      loading: false,
      length: ''
    }
  },
  methods: {
    getDataHistory() {
      this.loading = true
      this.fields.phone = localStorage.getItem('phone')
      this.fields.passcode = this.hash(this.fields.phone.toString())
      this.axios
        .post('https://irecharge.com.ng/api/misc/last_5_trans.php', this.fields)
        .then(response => {
          if (response.data.status == '0') {
            this.transactions = response.data.transactions
            this.length = this.transactions.length
          } else {
            $('.toast').hide()
            M.toast({ html: response.data.message, classes: 'info' })
          }
          if (response.data.message == 'Unauthorized Access') {
            $('.toast').hide()
            M.toast({
              html: 'We could not verify, please try again.',
              classes: 'error'
            })
          }
          this.loading = false
        })
        .catch(error => {
          $('.toast').hide()
          this.loading = false
        })
    },
    hash(ref) {
      let passcode = '123NDSx'
      let encrypted = CryptoJS.HmacSHA512(ref, passcode)
      return encrypted.toString()
    }
  }
}
</script>
<style scoped>
.card {
  padding: 15px 20px;
}
</style>
